import { Listbox } from "@headlessui/react";
import React from "react";
import tw from "twin.macro";
import { styled } from "~/config/stitches";

const SelectButton = styled(Listbox.Button, {
  // temporary disabling outlines until "we make beautiful ones"
  // ...tw`focus:outline-none focus:ring-1 focus:ring-slate-400 focus:border-slate-400`,
  ...tw`
  relative w-full 
  bg-white border border-gray-300 
  rounded-md shadow-sm 
  text-left cursor-default 
  `,
  defaultVariants: {
    rounded: false,
  },
  variants: {
    rounded: {
      true: {
        borderRadius: "$full",
      },
    },
  },
});

const SelectButtonWrapper = (
  props: SelectButtonProps & { children: React.ReactNode }
) => <SelectButton {...props} />;

type SelectButtonProps = React.ComponentProps<typeof SelectButton> & {
  children: React.ReactNode;
};

export { SelectButtonWrapper as SelectButton };
export type { SelectButtonProps };
